import { INVALID_RESOURCE_ERR, RESOURCE_TYPES } from '../constants';
export default function useGetPrintUrl(sharesContext, client) {
  var SHARES_URL = sharesContext.SHARES_URL;
  var getPrintUrl = function getPrintUrl(_ref) {
    var resourceType = _ref.resourceType,
      resourceIds = _ref.resourceIds,
      language = _ref.language,
      latitude = _ref.latitude,
      longitude = _ref.longitude,
      providerId = _ref.providerId;
    var typeId;
    switch (resourceType) {
      case RESOURCE_TYPES.program:
        typeId = 'programId';
        break;
      case RESOURCE_TYPES.provider:
        typeId = 'groupId';
        break;
      default:
        throw INVALID_RESOURCE_ERR;
    }
    var url = "".concat(SHARES_URL, "/?").concat(typeId, "=").concat(resourceIds.join(','), "&print=true");
    if (language) {
      url += "&language=".concat(language);
    }
    if (client) {
      url += "&client=".concat(client);
    }
    if (providerId) {
      url += "&providerId=".concat(providerId);
    }
    if (latitude && longitude) {
      url += "&lat=".concat(latitude, "&lon=").concat(longitude);
    }
    return url;
  };
  return getPrintUrl;
}
//# sourceMappingURL=useGetPrintUrl.js.map